<template>
  <td class="flex w-full">
    <slot />
  </td>
</template>
